var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 22") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0005 25 0.0005 25 25 0 25"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Humana-tray-110420",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Web_Uber-welcome-tray_v2b-Copy",
    transform: "translate(-33.000000, -565.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(33.000000, 565.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,1.4785 C9.105,1.4785 6.303,2.4865 4.395,4.3945 C2.487,6.3025 1.479,9.1055 1.479,12.5005 C1.479,15.8945 2.487,18.6975 4.395,20.6055 C6.303,22.5135 9.105,23.5215 12.5,23.5215 C15.895,23.5215 18.697,22.5135 20.605,20.6055 C22.513,18.6975 23.521,15.8945 23.521,12.5005 C23.521,9.1055 22.513,6.3025 20.605,4.3945 C18.697,2.4865 15.895,1.4785 12.5,1.4785 M12.5,25.0005 C8.705,25.0005 5.541,23.8415 3.349,21.6505 C1.158,19.4595 0,16.2955 0,12.5005 C0,8.7045 1.158,5.5405 3.349,3.3495 C5.541,1.1585 8.705,0.0005 12.5,0.0005 C16.295,0.0005 19.459,1.1585 21.651,3.3495 C23.842,5.5405 25,8.7045 25,12.5005 C25,16.2955 23.842,19.4595 21.651,21.6505 C19.459,23.8415 16.295,25.0005 12.5,25.0005",
    id: "Fill-1",
    fill: "#F5426E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M4.6308,13.2393 L3.2808,13.2393 C2.8718,13.2393 2.5408,12.9083 2.5408,12.5003 C2.5408,12.0913 2.8718,11.7603 3.2808,11.7603 L4.6308,11.7603 C5.0388,11.7603 5.3698,12.0913 5.3698,12.5003 C5.3698,12.9083 5.0388,13.2393 4.6308,13.2393",
    id: "Fill-4",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.0583,19.7263 C5.8693,19.7263 5.6803,19.6543 5.5353,19.5093 C5.2473,19.2213 5.2473,18.7533 5.5353,18.4643 L6.4903,17.5093 C6.7793,17.2213 7.2473,17.2213 7.5363,17.5093 C7.8243,17.7983 7.8243,18.2663 7.5363,18.5553 L6.5813,19.5103 C6.4363,19.6543 6.2473,19.7263 6.0583,19.7263",
    id: "Fill-6",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6096,22.3491 C12.2016,22.3491 11.8706,22.0181 11.8706,21.6101 L11.8706,20.2601 C11.8706,19.8511 12.2016,19.5201 12.6096,19.5201 C13.0176,19.5201 13.3486,19.8511 13.3486,20.2601 L13.3486,21.6101 C13.3486,22.0181 13.0176,22.3491 12.6096,22.3491",
    id: "Fill-8",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0966,19.5713 C18.9076,19.5713 18.7186,19.4993 18.5736,19.3543 L17.6186,18.4003 C17.3306,18.1113 17.3306,17.6433 17.6186,17.3543 C17.9076,17.0663 18.3756,17.0663 18.6646,17.3543 L19.6196,18.3093 C19.9086,18.5983 19.9086,19.0663 19.6196,19.3543 C19.4746,19.4993 19.2856,19.5713 19.0966,19.5713",
    id: "Fill-10",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7194,13.0201 L20.3694,13.0201 C19.9614,13.0201 19.6304,12.6891 19.6304,12.2811 C19.6304,11.8721 19.9614,11.5421 20.3694,11.5421 L21.7194,11.5421 C22.1274,11.5421 22.4584,11.8721 22.4584,12.2811 C22.4584,12.6891 22.1274,13.0201 21.7194,13.0201",
    id: "Fill-12",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3903,5.2603 C11.9823,5.2603 11.6513,4.9293 11.6513,4.5213 L11.6513,3.1713 C11.6513,2.7623 11.9823,2.4313 12.3903,2.4313 C12.7983,2.4313 13.1293,2.7623 13.1293,3.1713 L13.1293,4.5213 C13.1293,4.9293 12.7983,5.2603 12.3903,5.2603",
    id: "Fill-14",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.987,7.4877 C17.798,7.4877 17.609,7.4157 17.464,7.2707 C17.175,6.9827 17.175,6.5147 17.464,6.2257 L18.419,5.2707 C18.708,4.9827 19.176,4.9827 19.464,5.2707 C19.753,5.5597 19.753,6.0277 19.464,6.3167 L18.51,7.2707 C18.365,7.4157 18.176,7.4877 17.987,7.4877",
    id: "Fill-16",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8581,7.6427 C6.6691,7.6427 6.4801,7.5707 6.3351,7.4267 L5.3801,6.4717 C5.0921,6.1827 5.0921,5.7147 5.3801,5.4257 C5.6691,5.1377 6.1371,5.1377 6.4261,5.4257 L7.3811,6.3807 C7.6691,6.6697 7.6691,7.1377 7.3811,7.4267 C7.2361,7.5707 7.0471,7.6427 6.8581,7.6427",
    id: "Fill-18",
    fill: "#F5426E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,13.1296 L8.998,13.1296 C8.59,13.1296 8.259,12.7986 8.259,12.3906 C8.259,11.9816 8.59,11.6516 8.998,11.6516 L12.003,11.6516 L13.947,6.8816 C14.101,6.5036 14.533,6.3216 14.911,6.4756 C15.289,6.6296 15.47,7.0616 15.316,7.4396 L13.185,12.6696 C13.071,12.9476 12.801,13.1296 12.5,13.1296",
    id: "Fill-20",
    fill: "#F5426E"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9fd543adbaea36d07b3de89102efc4ea.svg";
export { ForwardRef as ReactComponent };